import React from "react";
import { Box, Typography, useTheme, ButtonBase } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface StatisticsCardProps {
  value: string | number;
  text: string;
  icon: React.ReactNode;
  onClick?: () => void;
}

const StatisticsCard: React.FC<StatisticsCardProps> = ({
  value,
  text,
  icon,
  onClick,
}) => {
  const theme = useTheme();

  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        flex: "1 1 250px", // Makes the cards grow responsively
        height: "100%",
        p: 3,
        backgroundColor: theme.palette.background.paper,
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.04)",
        borderRadius: 2,
        overflow: "hidden",
        border: `1px solid ${theme.palette.neutral[200]}`,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        minWidth: "250px", // Ensures they don’t shrink too much
        alignItems: "center",
        textAlign: "center",
        cursor: onClick ? "pointer" : "default", // Shows pointer cursor only if clickable
        transition: "background 0.2s ease",
        "&:hover": {
          backgroundColor: onClick ? theme.palette.neutral[100] : "inherit",
        },
      }}
    >
      {/* Icon at the top */}
      <Box
        sx={{
          width: 24,
          height: 24,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: theme.palette.info.main,
        }}
      >
        {icon}
      </Box>

      {/* Data Section with Chevron */}
      <Box
        sx={{
          display: "flex",
          justifyContent: onClick ? "space-between" : "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Text Data */}
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="h3"
            sx={{ color: theme.palette.primary.main, fontWeight: 700 }}
          >
            {value}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.primary.main,

              fontWeight: 400,
            }}
          >
            {text}
          </Typography>
        </Box>

        {/* Chevron Right Icon */}
        {onClick && (
          <Box
            sx={{
              color: theme.palette.neutral[600],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ChevronRightIcon />
          </Box>
        )}
      </Box>
    </ButtonBase>
  );
};

export default StatisticsCard;
